<!--  -->
<template>
  <el-form-item
    :label="name"
    :prop="code"
    :rules="rules"
  >
    <el-tooltip
      content="点击上传文件"
      placement="top"
      :disabled="disabled"
    >
      <el-input
        v-model="val"
        :disabled="disabled"
        placeholder="点击上传文件"
        style="width: calc(100% - 30px);"
        @focus="dialogVisible=true"
      />
    </el-tooltip>

    <el-tooltip
      content="点击上传文件"
      placement="top"
      :disabled="disabled"
    >
      <i class="el-icon-upload" />
    </el-tooltip>

    <el-dialog width="500px" :visible.sync="dialogVisible">
      <div class="file-upload-container">
        <el-upload
          action="#"
          :data="{ 'token': token }"
          :accept="accept"
          list-type="text"
          :file-list="previewList"
          :limit="1"
          :http-request="uploadFile"
          :on-remove="handleRemove"
          :on-exceed="handleExceed"
        >
          <template #trigger>
            <div class="h-full trigger-con flex flex-col align-center justify-center">
              <img src="@/assets/list/plus.png" alt="" class="plus-icon">
              <span class="icon-label">上传</span>
            </div>
          </template>
        </el-upload>
        <!-- 辅助信息 -->
        <span class="tips">
          {{ tips || '支持上传各种文件类型' }}
        </span>
      </div>
    </el-dialog>
  </el-form-item>

</template>

<script>
import { createClient, getSrc } from '@/utils/ik/oss/oss.js'

export default {
  name: 'IkFormFile',
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: Array,
      default: () => []
    },
    tips: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      val: '',
      dialogVisible: false,
      previewList: [],
      client: null,
      token: this.$store.getters['user/getToken'],
      loading: false
    }
  },
  computed: {
    accept() {
      return this.fileType.join(',')
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.val = val
          this.getUrl()
        } else {
          this.val = ''
          this.previewList = []
        }
      },
      immediate: true
    }
  },
  created() {
    this.client = createClient()
  },
  methods: {
    // 生成唯一ID (从FormImageItem复制)
    guidGenerator() {
      const S4 = () =>
        ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1)
      return `${S4()}${S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`
    },

    /**
     * 上传文件 (修改路径生成逻辑)
     */
    uploadFile(item) {
      this.loading = true
      const file = item.file
      const fileExtension = file.name.split('.').pop()

      // 使用与图片相同的路径格式
      const key = `test/time=${new Date().getTime()}&id=${this.guidGenerator()}.${fileExtension}`

      this.client.put(key, file, {
        "x-oss-forbid-overwrite": true
      }).then(res => {
        // 存储OSS路径而非完整URL
        this.val = key
        this.$emit('input', key)
        this.getUrl()
        this.dialogVisible = false
      }).catch(err => {
        console.error('文件上传失败', err)
        this.$message.error('文件上传失败')
      }).finally(() => {
        this.loading = false
      })
    },

    /**
     * 获取文件URL (修改为使用getSrc)
     */
    getUrl() {
      if (this.val) {
        const fileName = this.val.split('/').pop() || '文件'
        const url = getSrc(this.client, this.val) // 生成可访问URL

        this.previewList = [{
          name: fileName,
          url: url,
          uid: "file_" + Date.now()
        }]
      } else {
        this.previewList = []
      }
    },

    /**
     * 删除文件
     */
    handleRemove() {
      this.previewList = []
      this.val = ''
      this.$emit('input', '')
    },

    /**
     * 处理文件超出限制
     */
    handleExceed() {
      this.$message.warning('只能上传一个文件')
    }
  }
}
</script>

<!-- 样式保持不变 -->
<style lang="scss" scoped>
.trigger-con {
  .plus-icon {
    width: 20px;
    height: 20px;
    margin-bottom: 10px;
  }

  .icon-label {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: 400;
    font-size: 14px;
    color: #4E5969;
    line-height: 22px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}

::v-deep .el-upload--picture-card {
  width: 120px;
  height: 120px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}

.image-upload-container {
  margin: 0 auto;
  background-color: #F2F3F5;
  padding: 12px;
  width: 408px;
  height: 198px;
  border-radius: 4px 4px 4px 4px;

  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
    margin-bottom: 12px;

    &:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      text-align: center;
    }

    .avatar {
      display: block;
    }
  }

  .tips {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 12px;
    color: #86909C;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
